/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_ProfileInputs */



/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Layout_Header_ProfileInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_profile = /** @type {((inputs?: Layout_Header_ProfileInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_ProfileInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Profil")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Profil")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("个人资料")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("個人檔案")
	if (locale === "ko") return /** @type {LocalizedString} */ ("프로필")
	return /** @type {LocalizedString} */ ("Profile")
});